import { BUS_LIST_COLUMN } from "./actionTypes";

// List Shipping Unit
export const setListBusColumn = (field, value) => ({
  type: BUS_LIST_COLUMN,
  payload: { field, value },
});

// // List Job Title
// export const listJobTitle = (params = {}) => ({
//   type: JOB_TITLE_LIST,
//   payload: { params },
// });

// export const listJobTitleSuccess = data => ({
//   type: JOB_TITLE_LIST_SUCCESS,
//   payload: data,
// });

// export const listJobTitleFail = error => ({
//   type: JOB_TITLE_LIST_FAIL,
//   payload: error,
// });

// export const resetListJobTitle = () => ({
//   type: JOB_TITLE_LIST_RESET,
//   payload: {},
// });

// export const setListJobTitleColumn = (field, value) => ({
//   type: JOB_TITLE_LIST_COLUMN,
//   payload: { field, value },
// });

// // Create Job Title
// export const createJobTitle = jobTitleCreate => ({
//   type: JOB_TITLE_CREATE,
//   payload: { jobTitleCreate },
// });

// export const createJobTitleSuccess = data => ({
//   type: JOB_TITLE_CREATE_SUCCESS,
//   payload: data,
// });

// export const createJobTitleFail = error => ({
//   type: JOB_TITLE_CREATE_FAIL,
//   payload: error,
// });

// export const resetCreateJobTitle = () => ({
//   type: JOB_TITLE_CREATE_RESET,
//   payload: {},
// });

// // Detail Job Title
// export const detailJobTitle = (jobTitleId, params = {}) => ({
//   type: JOB_TITLE_DETAIL,
//   payload: { jobTitleId, params },
// });

// export const detailJobTitleSuccess = data => ({
//   type: JOB_TITLE_DETAIL_SUCCESS,
//   payload: data,
// });

// export const detailJobTitleFail = error => ({
//   type: JOB_TITLE_DETAIL_FAIL,
//   payload: error,
// });

// export const resetDetailJobTitle = () => ({
//   type: JOB_TITLE_DETAIL_RESET,
//   payload: {},
// });

// // Update Job Title
// export const updateJobTitle = (jobTitleId, data = {}) => ({
//   type: JOB_TITLE_UPDATE,
//   payload: { jobTitleId, data },
// });

// export const updateJobTitleSuccess = data => ({
//   type: JOB_TITLE_UPDATE_SUCCESS,
//   payload: data,
// });

// export const updateJobTitleFail = error => ({
//   type: JOB_TITLE_UPDATE_FAIL,
//   payload: error,
// });

// export const resetUpdateJobTitle = () => ({
//   type: JOB_TITLE_UPDATE_RESET,
//   payload: {},
// });

// // Delete Job Title
// export const deleteJobTitle = jobTitleId => ({
//   type: JOB_TITLE_DELETE,
//   payload: { jobTitleId },
// });

// export const deleteJobTitleSuccess = data => ({
//   type: JOB_TITLE_DELETE_SUCCESS,
//   payload: data,
// });

// export const deleteJobTitleFail = error => ({
//   type: JOB_TITLE_DELETE_FAIL,
//   payload: error,
// });

// export const resetDeleteJobTitle = () => ({
//   type: JOB_TITLE_DELETE_RESET,
//   payload: {},
// });

// // Active Job Title
// export const activeJobTitle = (jobTitleId, data = {}) => ({
//   type: JOB_TITLE_ACTIVE,
//   payload: { jobTitleId, data },
// });

// export const activeJobTitleSuccess = data => ({
//   type: JOB_TITLE_ACTIVE_SUCCESS,
//   payload: data,
// });

// export const activeJobTitleFail = error => ({
//   type: JOB_TITLE_ACTIVE_FAIL,
//   payload: error,
// });

// export const resetActiveJobTitle = () => ({
//   type: JOB_TITLE_ACTIVE_RESET,
//   payload: {},
// });
